export default "__VITE_ASSET__DwRqIy7x__"